import React, { useState } from 'react';
import moment from 'moment';
import { FormGroup, Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import { Calendar } from 'react-date-range';
import MaskedInput from '../../../shared/components/inputs/Masked';
import { DEFAULT_TIMESTAMP_FORMAT } from '../../../constants/constants';

export default function DatePickerComponent({
  handleChange,
  date,
  viewMode,
  minDate,
  maxDate,
  disabled,
  portalMenu = false,
  compact = false,
}) {
  const [dropdownOpen, setIsDropdownpen] = useState(false);

  const isDisabled = !!viewMode || !!disabled;

  const toggle = () => {
    if (isDisabled) return;
    setIsDropdownpen((state) => !state);
  };

  const handleDate = (e) => handleChange(e.target.value);

  const selectDate = (date) => {
    const dateString = moment(date).format(DEFAULT_TIMESTAMP_FORMAT);
    handleChange(dateString);
    toggle();
  };

  const displayDate = date && moment(date).isValid() ? date : null;

  const calendarMinDate =
    minDate === true
      ? new Date()
      : minDate
        ? new Date(minDate)
        : undefined;

  return (
<Dropdown
  className={
    'custom-date-picker' + (compact ? ' custom-date-picker--compact' : '')
  }
  isOpen={dropdownOpen}
  toggle={toggle}
>
      <DropdownToggle
        disabled={isDisabled}
        className="form-control dropdown-toggle-btn"
        onClick={() => toggle()}
      >
        <FormGroup>
          <MaskedInput
            mask="date"
            placeholder="MM/DD/YYYY"
            value={date || ''}
            onClick={() => toggle()}
            onChange={handleDate}
            autoComplete="off"
            disabled={isDisabled}
          />
        </FormGroup>
      </DropdownToggle>
<DropdownMenu
  className={compact ? 'custom-date-picker-menu--compact' : undefined}
  {...(portalMenu
    ? {
        container: document.body,
        strategy: 'fixed',
        style: { zIndex: 2000 },
      }
    : {})}
>
        {minDate && !maxDate && (
          <Calendar
            date={displayDate ? new Date(displayDate) : calendarMinDate || new Date()}
            minDate={calendarMinDate}
            onChange={selectDate}
          />
        )}
        {!minDate && maxDate && (
          <Calendar
            date={displayDate ? new Date(displayDate) : new Date()}
            maxDate={new Date()}
            onChange={selectDate}
          />
        )}
      </DropdownMenu>
    </Dropdown>
  );
}
